import { Ruleset } from "../../game/Ruleset.js";


export class LeaderboardGrouping {
    public static readonly OVERALL = new LeaderboardGrouping("overall", "Overall", null);
    public static readonly FINKEL = new LeaderboardGrouping("finkel", "Finkel", Ruleset.FINKEL);
    public static readonly BLITZ = new LeaderboardGrouping("blitz", "Blitz", Ruleset.BLITZ);
    public static readonly MASTERS = new LeaderboardGrouping("masters", "Masters", Ruleset.MASTERS);

    static values(): LeaderboardGrouping[] {
        return [
            LeaderboardGrouping.OVERALL,
            LeaderboardGrouping.FINKEL,
            LeaderboardGrouping.BLITZ,
            LeaderboardGrouping.MASTERS,
        ];
    }

    private readonly id: string;
    private readonly name: string;
    private readonly ruleset: Ruleset | null;

    constructor(id: string, name: string, ruleset: Ruleset | null) {
        this.id = id;
        this.name = name;
        this.ruleset = ruleset;
    }

    getID(): string {
        return this.id;
    }

    getName(): string {
        return this.name;
    }

    getRulesetOrNull(): Ruleset | null {
        return this.ruleset;
    }

    static getByID(id: string): LeaderboardGrouping {
        for (const leaderboardType of LeaderboardGrouping.values()) {
            if (leaderboardType.id === id)
                return leaderboardType;
        }
        throw new Error("Unknown game mode " + id);
    }

    static getByIDOrNull(id: string | null): LeaderboardGrouping | null {
        if (id === null)
            return null;

        for (const leaderboardType of LeaderboardGrouping.values()) {
            if (leaderboardType.id === id)
                return leaderboardType;
        }
        return null;
    }
}
